<div class="tab-content">
  <div [formGroup]="riskDepartmentDropDown">
    <div class="row">
      <div class="col-md-3" *ngIf="isAdmin">
        <div class="form-group">
          <label for="lblDepartment" class="col-form-label">
            <span translate>CHOOSE_BUSINESS</span>
          </label>
          <div>
            <p-select
              [options]="Business"
              [filter]="true"
              [style]="{ width: '160px' }"
              formControlName="businessId"
              (onChange)="onBusinessChanged($event, businessDropdown)"
              #businessDropdown
            ></p-select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--Approved all notices  datatable-->
  <div class="" *ngIf="!isAdmin">
    <div class="row">
      <div class="col-md-8">
        <h4 translate>RISK_ANALYSIS</h4>
        <app-riskanalysis-list-chart [riskDetails]="riskDetails">
        </app-riskanalysis-list-chart>
      </div>
      <div class="col-md-4">
        <h4 translate>CONFIRMED</h4>
        <!-- Table starts -->
        <p-table
          [value]="approvalNotices"
          dataKey="Name"
          #approvalTable
          expandableRows="true"
          [rows]="5"
          [paginator]="true"
          [pageLinks]="3"
          [rowsPerPageOptions]="[5, 10, 20]"
        >
          <!-- Header -->
          <ng-template pTemplate="header">
            <tr>
              <th></th>
              <th>{{ "EMPLOYEE_NAME" | translate }}</th>
              <th>{{ "STATUS" | translate }}</th>
            </tr>
          </ng-template>
          <!-- Body Content -->
          <ng-template
            pTemplate="body"
            let-risk
            let-expanded="expanded"
            let-i="rowIndex"
          >
            <tr>
              <td>
                <a (click)="approvalTable.toggleRow(risk)" class="btn btn-icon">
                  <span
                    class="icon ic-sm icon-expand-arrow"
                    aria-hidden="true"
                    *ngIf="setCollapse(i)"
                    (click)="toggleClick(i)"
                  ></span>
                  <span
                    class="icon ic-sm icon-collapse-arrow"
                    aria-hidden="true"
                    *ngIf="!setCollapse(i)"
                    (click)="toggleClickHide()"
                  ></span>
                </a>
              </td>
              <td>
                <span>{{ risk.Name }}</span>
              </td>
              <td>
                <span>{{ risk.Count }}/{{ totalIncidents }}</span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="expandedrow" let-risk>
            <tr>
              <td colspan="3">
                <div>
                  <!-- Table starts -->
                  <p-table
                    [value]="risk.RiskAnalysis"
                    [rows]="5"
                    [showCurrentPageReport]="true"
                    currentPageReportTemplate="{{
                      'SUMMARY_TOTALRECORDS' | translate
                    }}"
                  >
                    <ng-template pTemplate="header">
                      <tr>
                        <th>{{ "INCIDENT_STRESS" | translate }}</th>
                        <th>{{ "LOCATION" | translate }}</th>
                        <th>{{ "APPROVED_DATE" | translate }}</th>
                        <th>{{ "EDITED_ON" | translate }}</th>
                      </tr>
                    </ng-template>
                    <!-- Body Content -->
                    <ng-template pTemplate="body" let-risks>
                      <tr>
                        <td>
                          <span>
                            {{
                              risks.Title.length > 58
                                ? (risks.Title | slice: 0 : 58) + ".."
                                : risks.Title
                            }}</span
                          >
                        </td>
                        <td>
                          <span>{{ risks.GPSLocation }}</span>
                        </td>
                        <td>
                          <span
                            [style.color]="risks.ApprovedOn ? 'Green' : 'black'"
                            >{{
                              risks.ApprovedOn
                                ? (risks.ApprovedOn | date: "dd/MM/yyyy")
                                : ("UNAPPROVED" | translate)
                            }}</span
                          >
                        </td>
                        <td>
                          <span
                            [style.color]="
                              risks.ApprovedOn
                                ? risks.ModifiedOn
                                  ? 'black'
                                  : 'Green'
                                : 'red'
                            "
                            >{{ risks.ModifiedOn | date: "dd/MM/yyyy" }}</span
                          >
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <!-- Table ends -->
      </div>
    </div>
  </div>
  <!--Approved all notices  datatable ends-->
  <div class="row">
    <div class="col-md-12">
      <div class="page-title">
        <h4 translate>RISK_FACTORS</h4>
        <span class="page-actions" *ngIf="isAdministrateRiskAnalysis">
          <button
            *ngIf="!isAdmin"
            type="button"
            class="btn btn-success"
            (click)="gotoNew()"
          >
            <i class="pi pi-plus"></i>
            <span translate>NEW</span>
          </button>
        </span>
      </div>

      <div class="custom table-view mbtm-30">
        <!-- Table starts -->
        <p-table
          styleClass="kuba-risk-table"
          [value]="riskDetails"
          #riskTable
          dataKey="Id"
          [rows]="50"
          [paginator]="true"
          [pageLinks]="3"
          [rowsPerPageOptions]="[50, 100, 200]"
          [(selection)]="selectedRisks"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{{ 'SUMMARY_TOTALRECORDS' | translate }}"
          selectionMode="multiple"
        >
          <!-- Header -->
          <ng-template pTemplate="caption">
            <div class="ui-helper-clearfix">
              <div class="filter-controls-wrapper" style="display: none">
                <div class="row">
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label for="lblDepartment" class="control-label">
                        <span translate>DEPARTMENT</span>
                      </label>
                      <div>
                        <p-select
                          [options]="departments"
                          [filter]="true"
                          [style]="{ width: '160px' }"
                          (onChange)="
                            onFilterValueChanged($event, 'department')
                          "
                          #departmentDropdown
                        ></p-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label class="control-label">
                        <span translate>SORTING</span>
                      </label>
                      <div>
                        <p-select
                          [style]="{ width: '160px' }"
                          type="text"
                          (onChange)="onFilterValueChanged($event, 'sorting')"
                          [options]="sorting"
                          #sortingDropdown
                        ></p-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label for="lblLocation" class="control-label">
                        <span translate>LOCATION</span>
                      </label>
                      <input
                        #locationFilterInput
                        pInputText
                        type="text"
                        (input)="
                          riskTable.filter(
                            $event.target.value,
                            'Location',
                            'contains'
                          )
                        "
                        placeholder=""
                        class="p-column-filter"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-options">
                <div class="pull-right filter-btn-container">
                  <button class="btn btn-link" (click)="resetFilters()">
                    <i class="pi pi-refresh me-2"></i>
                    <span translate>RESET_FILTERS</span>
                  </button>
                  <button class="btn btn-link filter-toggle">
                    <span class="icon ic-sm icon-filter"></span>
                    <span translate>FILTER</span>
                  </button>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th class="risk-column-select"></th>
              <th class="risk-column-icon"></th>
              <th
                class="risk-column-business"
                *ngIf="isPortal"
                pSortableColumn="Business"
              >
                {{ "BUSINESS" | translate }}
                <p-sortIcon field="Business"></p-sortIcon>
              </th>
              <th class="risk-column-category" pSortableColumn="Category">
                {{ "CATEGORY" | translate }}
                <p-sortIcon field="Category"></p-sortIcon>
              </th>
              <th class="risk-column-title" pSortableColumn="Title">
                {{ "INCIDENT_STRESS" | translate }}
                <p-sortIcon field="Title"></p-sortIcon>
              </th>
              <th class="risk-column-topics" pSortableColumn="Topics">
                {{ "TOPICS" | translate }}
                <p-sortIcon field="Topics"></p-sortIcon>
              </th>
              <th class="risk-column-figure" pSortableColumn="ValueText">
                {{ "RISK_FIGURE" | translate }}
                <p-sortIcon field="ValueText"></p-sortIcon>
              </th>
              <th class="risk-column-description" pSortableColumn="Description">
                {{ "WHAT_CAN_HAPPEN" | translate }}
                <p-sortIcon field="Description"></p-sortIcon>
              </th>
              <th class="risk-column-date" pSortableColumn="ModifiedOn">
                {{ "EDITED_ON" | translate }}
                <p-sortIcon field="ModifiedOn"></p-sortIcon>
              </th>
              <th class="risk-column-approval" pSortableColumn="ApprovalStatus">
                {{ "CONFIRMED" | translate }}
                <p-sortIcon field="ApprovalStatus"></p-sortIcon>
              </th>
              <th class="risk-column-actions" *ngIf="!isGuest && !isAdmin">
                {{ "OPTIONS" | translate }}
              </th>
            </tr>
            <tr>
              <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
              <th></th>
              <th *ngIf="isPortal">
                <input
                  pInputText
                  type="text"
                  (input)="
                    riskTable.filter(
                      $event.target.value,
                      'Business',
                      'contains'
                    )
                  "
                  placeholder=""
                  class="p-column-filter"
                />
              </th>
              <th>
                <p-select
                  [options]="Category"
                  (onChange)="onFilterValueChanged($event, 'category')"
                  #cd
                  styleClass="p-column-filter"
                  placeholder="Select"
                  [filter]="true"
                  [filterBy]="'label'"
                  [showClear]="true"
                >
                  <ng-template let-categoryOption pTemplate="item">
                    <span
                      *ngIf="
                        categoryOption?.value != null;
                        else categoryOptionText
                      "
                      class="risk-category-badge"
                      [ngStyle]="getCategoryBadgeStyle(categoryOption.value)"
                    >
                      {{ categoryOption.label | translate }}
                    </span>
                    <ng-template #categoryOptionText>
                      <span>{{ categoryOption?.label | translate }}</span>
                    </ng-template>
                  </ng-template>
                  <ng-template let-categoryOption pTemplate="selectedItem">
                    <span
                      *ngIf="
                        categoryOption?.value != null;
                        else selectedCategoryText
                      "
                      class="risk-category-badge"
                      [ngStyle]="getCategoryBadgeStyle(categoryOption?.value)"
                    >
                      {{ categoryOption?.label | translate }}
                    </span>
                    <ng-template #selectedCategoryText>
                      <span>{{
                        categoryOption?.label || "Select" | translate
                      }}</span>
                    </ng-template>
                  </ng-template>
                </p-select>
              </th>
              <th>
                <input
                  #titleFilterInput
                  pInputText
                  type="text"
                  (input)="
                    riskTable.filter($event.target.value, 'Title', 'contains')
                  "
                  placeholder=""
                  class="p-column-filter"
                />
              </th>
              <th>
                <input
                  #topicFilterInput
                  pInputText
                  type="text"
                  (input)="
                    riskTable.filter($event.target.value, 'Topics', 'contains')
                  "
                  placeholder=""
                  class="p-column-filter"
                />
              </th>
              <th>
                <p-select
                  [options]="Riskdata"
                  (onChange)="onFilterValueChanged($event, 'risk')"
                  #riskDropdown
                  styleClass="p-column-filter"
                  placeholder="Select"
                  [filterBy]="null"
                  [showClear]="true"
                >
                  <ng-template let-status pTemplate="item">
                    {{ status.label | translate }}
                  </ng-template>
                </p-select>
              </th>
              <th>
                <input
                  #descriptionFilterInput
                  pInputText
                  type="text"
                  (input)="
                    riskTable.filter(
                      $event.target.value,
                      'Description',
                      'contains'
                    )
                  "
                  placeholder=""
                  class="p-column-filter"
                />
              </th>
              <th></th>
              <th>
                <p-select
                  [options]="Approval"
                  (onChange)="onFilterValueChanged($event, 'approvalStatus')"
                  #approvalDropdown
                  styleClass="p-column-filter"
                  placeholder="Select"
                  [filterBy]="null"
                  [showClear]="true"
                >
                  <ng-template let-status pTemplate="item">
                    {{ status.label | translate }}
                  </ng-template>
                </p-select>
              </th>
              <th *ngIf="!isGuest && !isAdmin"></th>
            </tr>
          </ng-template>
          <!-- Body Content -->
          <ng-template pTemplate="body" let-risks>
            <tr>
              <td>
                <p-tableCheckbox id="selectedOrders" [value]="risks">
                </p-tableCheckbox>
              </td>
              <td>
                <div *ngIf="risks.StatusIcon && risks.StatusIcon !== 'null'">
                  <a
                    [class]="risks.StatusIcon"
                    (click)="ActionPlanDialog(risks.Id)"
                    href="javascript:void(0)"
                  >
                  </a>
                </div>
              </td>
              <td *ngIf="isPortal">
                <span>{{ risks.Business }}</span>
              </td>
              <td>
                <span
                  class="risk-category-badge"
                  [ngStyle]="getCategoryBadgeStyle(risks.CategoryId)"
                  pTooltip="{{
                    getRiskCategoryLabel(risks.CategoryId, risks.Category)
                      | translate
                  }}"
                  tooltipPosition="top"
                >
                  {{
                    getRiskCategoryLabel(risks.CategoryId, risks.Category)
                      | translate
                      | truncate: 58
                  }}
                </span>
              </td>
              <td *ngIf="isGuest || isPortal">
                <span pTooltip="{{ risks.Title }}" tooltipPosition="top">
                  {{ risks.Title | truncate: 58 }}
                </span>
              </td>
              <td *ngIf="!(isGuest || isPortal)">
                <a
                  href="javascript:void(0)"
                  (click)="RiskSchemeDialog(risks.Id)"
                  pTooltip="{{ risks.Title }}"
                  tooltipPosition="top"
                >
                  {{ risks.Title | truncate: 58 }}
                </a>
              </td>
              <td>
                <span>{{ risks.Topics }}</span>
              </td>
              <td>
                <span
                  class="badge"
                  translate
                  [style.background-color]="risks.RiskFigureData.BackColor"
                  >{{ risks.RiskFigureData.ValueText }}
                  <span>{{ risks.RiskFigureData.Value }}</span>
                </span>
              </td>
              <td
                style="
                  max-width: 200px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                "
              >
                <span pTooltip="{{ risks.Description }}" tooltipPosition="top">
                  {{ risks.Description | truncate: 58 }}
                </span>
              </td>
              <td>
                <span>{{ risks.ModifiedOn | date: "dd/MM/yyyy" }}</span>
              </td>
              <td>
                <span
                  [style.color]="
                    risks.ApprovalStatus == 'Approved' ? 'Green' : 'black'
                  "
                >
                  {{
                    (risks.ApprovalStatus == "Approved"
                      ? "APPROVED"
                      : "UNAPPROVED"
                    ) | translate
                  }}</span
                >
              </td>
              <td class="col-button" *ngIf="!isGuest && !isAdmin">
                <a
                  [routerLink]="['./edit-risk', risks.Id]"
                  
                  title="{{ 'EDIT' | translate }}" [attr.aria-label]="'EDIT' | translate" class="kuba-icon-btn kuba-icon-btn--ghost kuba-icon-btn--row"><i class="pi pi-pencil"></i></a>
                <button
                  type="button"
                  title="{{ 'DELETE' | translate }}"
                  (click)="confirm(risks.Id)"
            [attr.aria-label]="'DELETE' | translate" class="kuba-icon-btn kuba-icon-btn--danger kuba-icon-btn--row">
            <i class="pi pi-trash"></i>
          </button>
              </td>
            </tr>
          </ng-template>
          <!-- Empty message -->
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td
                [attr.colspan]="
                  9 + (isPortal ? 1 : 0) + (!isGuest && !isAdmin ? 1 : 0)
                "
              >
                {{ "NO_RECORDS_FOUND" | translate }}
              </td>
            </tr>
          </ng-template>
          <!-- Footer -->
          <ng-template pTemplate="summary">
            <div class="footer-data">
              <div class="symbol-descriptions">
                <div class="symbol-desc-title">
                  <span translate>DESCRIPTION_SYMBOLS</span>
                </div>
                <div class="symbol-desc-items">
                  <span>
                    <i class="icon ic-md icon-clear-deadline"></i>
                    <span translate>ACTION_DONE</span>
                  </span>
                  <span>
                    <i class="icon ic-md icon-far-deadline"></i>
                    <span translate>ACTION_NOT_PERFORMED</span>
                  </span>
                  <span class="text-primary">
                    <i class="icon ic-md icon-task-planning"></i>
                    <span translate>RISK_ACTION</span>
                  </span>
                </div>
              </div>
            </div>
          </ng-template>
        </p-table>
        <!-- Table ends -->
      </div>
      <div class="mbtm-30 action-btns-wrapper">
        <button
          type="button"
          class="btn btn-primary"
          (click)="saveApprovalNotice()"
          *ngIf="!IsApproveButton"
          [disabled]="isRmode"
          [title]="
            isRmode ? ('RMODE_FEATURE_DISABLED_TOOLTIP' | translate) : ''
          "
        >
          <span translate>CONFIRM_READ_BUTTON</span>
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="showDialog()"
          *ngIf="IsGenerateReport || IncidentList.length > 0"
        >
          <span translate>GENERATE_REPORT</span>
        </button>
        <button
          [ngClass]="{ loading: loadingMail }"
          type="button"
          class="btn btn-warning"
          (click)="sendReportMail()"
          *ngIf="IsSendEmail"
          [disabled]="!sendMail || loadingMail"
        >
          <span translate>SEND_MAIL</span>
          <span *ngIf="loadingMail" class="loader-icon"></span>
        </button>
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="toggleStaticData()"
        >
          <span translate>TOGGLE_GUIDE</span>
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="onPreviewClick()"
        >
          <span class="icon ic-sm icon-search"></span>
          <span translate>PREVIEW_REPORT</span>
        </button>
        <br />

        <span *ngIf="IsSendEmail" style="color: red" translate class="pt-1"
          >SEND_EMAIL_NOTIFICATION</span
        >
      </div>
    </div>
  </div>
  <!--Risk Analysis datatable ends-->

  <!--static data component-->
  <div class="row">
    <div class="col-md-12">
      <div *ngIf="showStaticData">
        <staticdata id="staticData"></staticdata>
      </div>
    </div>
  </div>

  <!--static data component ends-->
  <!--department p-dialog box-->

  <p-dialog
    header="{{ 'ADD_DEPARTMENT' | translate }}"
    [(visible)]="addType"
    [style]="{ width: '500px', height: '500px' }"
    [resizable]="false"
    [draggable]="false"
    (onHide)="onBeforeRiskDepartmentDialogHide()"
  >
    <form [formGroup]="riskAnalysisDepartment">
      <div class="form-group">
        <label for="title" class="col-form-label">
          <span translate>DEPARTMENT</span>
        </label>
        <div>
          <input
            type="text"
            #Name
            class="label-input form-control"
            formControlName="department"
          />
          <span style="color: red" *ngIf="isdepartmentExists">{{
            departmentExisting
          }}</span>
          <span style="color: red" *ngIf="isNameExists">{{
            existsAlerttext
          }}</span>
        </div>
      </div>
    </form>
    <ng-template pTemplate="footer">
      <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="viewType = !viewType"
        >
          <span translate>VIEW</span>
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="!riskAnalysisDepartment.valid"
          (click)="saveDept()"
        >
          <span translate>SAVE</span>
        </button>
      </div>
      <div *ngIf="viewType">
        <div class="table-view">
          <!-- Table starts -->
          <p-table
            [value]="editDepartments"
            [rows]="10"
            [paginator]="true"
            [pageLinks]="3"
            [rowsPerPageOptions]="[5, 10, 20]"
          >
            <!-- Header -->
            <ng-template pTemplate="header">
              <tr>
                <th>{{ "TYPE_NAME" | translate }}</th>
                <th></th>
              </tr>
            </ng-template>
            <!-- Body Content -->
            <ng-template pTemplate="body" let-riskdept>
              <tr>
                <td>
                  <span>{{ riskdept.Name }}</span>
                </td>
                <td class="col-button">
                  <button
                    type="button"
                    title="{{ 'EDIT' | translate }}"
                    (click)="editDeptType(riskdept)"
            [attr.aria-label]="'EDIT' | translate" class="kuba-icon-btn kuba-icon-btn--ghost kuba-icon-btn--row">
            <i class="pi pi-pencil"></i>
          </button>
                  <button
                    type="button"
                    title="{{ 'DELETE' | translate }}"
                    (click)="deleteDept(riskdept)"
            [attr.aria-label]="'DELETE' | translate" class="kuba-icon-btn kuba-icon-btn--danger kuba-icon-btn--row">
            <i class="pi pi-trash"></i>
          </button>
                </td>
              </tr>
            </ng-template>
          </p-table>
          <!-- Table Ends -->
        </div>
      </div>
    </ng-template>
  </p-dialog>
  <p-confirmDialog
    header="{{ 'CONFIRMATION' | translate }}"
    icon="pi pi-question-circle"
    width="425"
    acceptLabel="{{ 'SWITCH_YES' | translate }}"
    rejectLabel="{{ 'SWITCH_NO' | translate }}"
  ></p-confirmDialog>
  <p-dialog
    header="{{ 'NOTIFICATION' | translate }}"
    [(visible)]="showNotification"
    [style]="{ width: '600px' }"
    [resizable]="false"
    [draggable]="false"
    translate
  >
    <span translate>SELECT_ONERECORD</span>
  </p-dialog>
  <!--Panel Loader-->
  <p-dialog
    header="{{ 'ACTION_PLANS' | translate }}"
    [(visible)]="showActionPlan"
    [style]="{ width: '1000px' }"
    [resizable]="false"
    [draggable]="false"
    [modal]="true"
    (onHide)="closePopUp()"
    [contentStyle]="{ 'min-height': '300px' }"
  >
    <p-table [value]="ActionPlanList" [rows]="5">
      <!-- Header -->
      <ng-template pTemplate="header">
        <tr>
          <th></th>
          <th>{{ "ACTION_NAME" | translate }}</th>
          <th>{{ "DESCRIPTION" | translate }}</th>
          <th>{{ "GOAL" | translate }}</th>
          <th>{{ "STATUS" | translate }}</th>
          <th>{{ "DEADLINE" | translate }}</th>
          <th>{{ "RESPONSIBLE_PERSON" | translate }}</th>
          <th>{{ "FOLLOWUP_PERSON" | translate }}</th>
        </tr>
      </ng-template>
      <!-- Body Content -->
      <ng-template pTemplate="body" let-risk let-i="rowIndex">
        <tr [class.action-row-yellow]="isPreviewMode">
          <td>{{ i + 1 }}</td>
          <td>{{ risk.Title }}</td>
          <td>{{ risk.Description | translate }}</td>
          <td>{{ risk.Goal }}</td>
          <td>{{ risk.StatusText | translate }}</td>
          <td>{{ risk.Deadline | date: "dd/MM/yyyy" }}</td>
          <td>{{ risk.ResponsiblePerson }}</td>
          <td>{{ risk.FollowupPerson }}</td>
        </tr>
      </ng-template>
      <!-- Footer -->
      <ng-template pTemplate="summary">
        <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
          <button
            type="button"
            class="btn btn-outline-secondary"
            (click)="closePopUp()"
          >
            <span translate>CLOSE</span>
          </button>
        </div>
      </ng-template>
    </p-table>
    <!-- Table Ends -->
  </p-dialog>
  <p-dialog
    header="{{ 'RISK_SCHEME' | translate }}"
    [(visible)]="showRiskScheme"
    [modal]="true"
    [style]="{ width: '600px' }"
    [resizable]="false"
    [draggable]="false"
    translate
  >
    <form [formGroup]="riskForm">
      <div class="form-group">
        <div class="form-group" [hidden]="riskFormData?.CategoryId === null">
          <label for="lblCategory" class="col-form-label">
            <span translate>CATEGORY</span>
          </label>
          <div class="input-btn-group">
            <input
              [readonly]="true"
              type="text"
              formControlName="CategoryId"
              pInputText
            />
          </div>
        </div>
        <div class="form-group">
          <label for="lblIncidentStress" class="col-form-label">
            <span translate>INCIDENT_STRESS</span>
          </label>
          <div class="input-btn-group">
            <input
              [readonly]="true"
              type="text"
              id="txtIncidentStress"
              formControlName="Title"
              pInputText
            />
          </div>
        </div>
        <div class="form-group">
          <label for="lblLocation" class="col-form-label">
            <span translate>LOCATION</span>
          </label>
          <div class="input-btn-group">
            <input
              [readonly]="true"
              type="text"
              id="txtLocation"
              formControlName="Location"
              pInputText
              name="Location"
            />
          </div>
        </div>
        <div class="form-group">
          <label for="lblTopics" class="col-form-label">
            <span translate>TOPICS</span>
          </label>
          <div class="input-btn-group">
            <p-select
              [readonly]="true"
              [options]="Topics"
              type="text"
              formControlName="TopicId"
            >
            </p-select>
          </div>
        </div>
        <div class="form-group">
          <label for="lblDepartment" class="col-form-label">
            <span translate>DEPARTMENT</span>
          </label>
          <div class="input-btn-group" style="display: flex">
            <p-multiSelect
              [disabled]="true"
              [options]="departments"
              formControlName="DepartmentId"
              [style]="{ width: '336px' }"
              [placeholder]="'CHOOSE' | translate"
            ></p-multiSelect>
          </div>
        </div>
        <div class="form-group">
          <label class="col-form-label">
            <span translate>SORTING</span>
          </label>
          <div class="input-btn-group">
            <input
              [readonly]="true"
              pTextarea
              type="text"
              formControlName="Sorting"
            />
          </div>
        </div>
        <div class="form-group">
          <label for="lblWhathappend" class="col-form-label">
            <span translate>WHAT_CAN_HAPPEN</span>
          </label>
          <div class="input-btn-group">
            <textarea
              [readonly]="true"
              type="text"
              id="txtariaWhatHappend"
              pTextarea
              formControlName="ExpectedBehaviour"
            >
            </textarea>
          </div>
        </div>
        <div class="form-group">
          <label for="lblRelatedIncident" class="col-form-label">
            <span translate>RELATED_INCIDENT</span>
          </label>
          <div class="input-btn-group">
            <input
              type="text"
              [readonly]="true"
              id="txtRelatedIncident"
              formControlName="RelatedIncident"
              pInputText
            />
          </div>
        </div>
        <div class="form-group">
          <label for="lblActionTaken" class="col-form-label">
            <span translate>ACTION_ALREADY_TAKEN</span>
          </label>
          <div class="input-btn-group">
            <textarea
              type="text"
              [readonly]="true"
              id="txtariaActionTaken"
              formControlName="Alreadyactiontaken"
              pTextarea
            >
            </textarea>
          </div>
        </div>
        <div class="form-group">
          <label for="lblProbability" class="col-form-label">
            <span translate>PROBABILITY_FIGURE</span>
          </label>
          <div class="input-btn-group">
            <input
              [readonly]="true"
              type="text"
              formControlName="Probability"
              pInputText
            />
          </div>
        </div>
        <div class="form-group">
          <label for="lblConsequence" class="col-form-label">
            <span translate>CONSEQUENCE_FIGURE</span>
          </label>
          <div class="input-btn-group">
            <input
              [readonly]="true"
              type="text"
              formControlName="Consequence"
              pInputText
            />
          </div>
        </div>
        <label for="lblRisk" class="col-form-label">
          <span translate>RISK_FIGURE</span>
        </label>
        <div class="input-btn-group">
          <input
            [readonly]="true"
            type="text"
            [style.background-color]="riskData.backColor"
            pInputText
            class="ex-full-width"
            [value]="riskData.value | translate"
          />
        </div>
        <!-- </div> -->
        <div class="form-group">
          <label for="lblParticipants" class="col-form-label">
            <span translate>PARTICIPANTS</span>
          </label>
          <div class="input-btn-group">
            <input
              [readonly]="true"
              type="text"
              id="txtParticipants"
              formControlName="Participants"
              pInputText
            />
          </div>
        </div>
        <div class="form-group">
          <label for="lblCreatedOn" class="col-form-label">
            <span translate>CREATED_ON</span>
          </label>
          <div class="input-btn-group">
            <input
              [readonly]="true"
              type="text"
              id="txtCreatedOn"
              formControlName="CreatedOn"
              pInputText
            />
          </div>
        </div>
        <div class="form-group">
          <label for="lblModifiedOn" class="col-form-label">
            <span translate>MODIFIED_ON</span>
          </label>
          <div class="input-btn-group">
            <input
              [readonly]="true"
              type="text"
              id="txtModifiedOn"
              formControlName="ModifiedOn"
              pInputText
            />
          </div>
        </div>
        <div class="pull-right">
          <button
            type="submit"
            class="btn btn-outline-primary"
            (click)="exportPdf()"
            [ngClass]="{ loadingReport: loadingReport }"
          >
            <i class="pi pi-print"></i>
            <span *ngIf="!loadingReport" translate>PRINT_PAGE</span>
            <span *ngIf="loadingReport" translate>PROCESSING</span>
            <span *ngIf="loadingReport" class="loader-icon"></span>
          </button>
        </div>
      </div>
    </form>
  </p-dialog>
  <p-dialog
    header="{{ 'CONFIRMATION' | translate }}"
    [(visible)]="displayDialog"
    [style]="{ width: '350px' }"
    [resizable]="false"
    [draggable]="false"
    showEffect="fade"
    [modal]="true"
    [closable]="true"
  >
    <div class="confirmation-content">
      <span> {{ "APPROVAL_STATUS" | translate }}</span>
    </div>
    <div class="action-btns-wrapper">
      <div class="text-right">
        <button
          type="submit"
          class="btn btn-outline-primary"
          (click)="confirmGenerate(true)"
        >
          <span translate>Yes</span>
        </button>
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="confirmGenerate(false)"
        >
          <span translate>No</span>
        </button>
      </div>
    </div>
  </p-dialog>


<kuba-busy [busy]="loading" message="PROCESSING"></kuba-busy>

  <!--Panel Loader-->
</div>

<p-dialog
  header="{{ 'PREVIEW_REPORT' | translate }}"
  [(visible)]="showPreview"
  [modal]="true"
  styleClass="report-preview-dialog"
  [style]="{ width: '85vw' }"
  [resizable]="false"
  [draggable]="false"
  [maximizable]="true"
  [blockScroll]="true"
>
  <iframe *ngIf="previewUrl" [src]="previewUrl" class="preview-iframe">
  </iframe>
</p-dialog>
